import React, { createContext, useContext, useState } from 'react';

const ToolkitContext = createContext();

export const useToolkit = () => {
  const context = useContext(ToolkitContext);
  if (!context) {
    throw new Error('useToolkit must be used within a ToolkitProvider');
  }
  return context;
};

export const ToolkitProvider = ({ children }) => {
  const [toolkit, setToolkit] = useState({
    sports: [],
    music: [],
    clubs: []
  });

  const addTools = (persona, tools) => {
    setToolkit(prev => ({
      ...prev,
      [persona]: [...new Set([...prev[persona], ...tools])]
    }));
  };

  const removeTool = (persona, tool) => {
    setToolkit(prev => ({
      ...prev,
      [persona]: prev[persona].filter(t => t !== tool)
    }));
  };

  const clearPersona = (persona) => {
    setToolkit(prev => ({
      ...prev,
      [persona]: []
    }));
  };

  const getTotalTools = () => {
    return Object.values(toolkit).reduce((total, tools) => total + tools.length, 0);
  };

  const getPersonaTools = (persona) => {
    return toolkit[persona] || [];
  };

  const value = {
    toolkit,
    addTools,
    removeTool,
    clearPersona,
    getTotalTools,
    getPersonaTools,
  };

  return (
    <ToolkitContext.Provider value={value}>
      {children}
    </ToolkitContext.Provider>
  );
};
